import { createSelector } from "reselect";

import { bookingsSelector } from "./BookingSelectors";

const getState = state => state.blacklist
const isLoadingSelector = state => getState(state).isLoading
const isLoadingBlacklistModalSelector = state => getState(state).isLoadingBlacklistModal
const blacklistPageBookings = state => getState(state).blacklistPageBookings
const blacklistBookingsSelector = state => getState(state).blacklistBookings
const blacklistPassengerBookingsSelector = state => getState(state).blacklistPassengerBookings

const blacklistPageBookingsSelector = createSelector(
  bookingsSelector,
  (bookings) => bookings.filter(({ status }) => status === 'blacklist')
)

export {
  isLoadingSelector,
  isLoadingBlacklistModalSelector,
  blacklistBookingsSelector,
  blacklistPageBookingsSelector,
  blacklistPassengerBookingsSelector,
}



// WEBPACK FOOTER //
// ./src/reduxModules/selectors/BlacklistSelectors.js